<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="6" :sm="24">
              <a-form-item label="任务标题快照" prop="taskTitle">
                <a-input v-model="queryParam.taskTitle" :maxLength="32" :placeholder="$t('通用.输入.请输入')+'任务标题快照'" allow-clear @pressEnter="handleQuery"/>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="售后状态" prop="refundStatus">
                <a-select v-model="queryParam.refundStatus" placeholder="请选择售后状态" allow-clear>
                  <a-select-option :value="5010">待审核</a-select-option>
                  <a-select-option :value="5048">退款处理中</a-select-option>
                  <a-select-option :value="5050">退款完成</a-select-option>
                  <a-select-option :value="5060">卖家拒绝</a-select-option>
                  <a-select-option :value="5070">售后关闭</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>

            <a-col :md="!advanced && 6 || 24" :sm="24">
              <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />{{$t('通用.按钮.查询')}}</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />{{$t('通用.按钮.重置')}}</a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <!-- 操作 -->
      <div class="table-operations">
        <!-- <a-button type="primary" @click="$refs.createForm.handleAdd()" v-hasPermi="['task:taskorderrefund:add']">
          <a-icon type="plus" />{{$t('通用.按钮.新增')}}
        </a-button>
        <a-button type="primary" :disabled="single" @click="$refs.createForm.handleUpdate(undefined, ids)" v-hasPermi="['task:taskorderrefund:edit']">
          <a-icon type="edit" />{{$t('通用.按钮.修改')}}
        </a-button> -->
        <a-button type="danger" :disabled="multiple" @click="handleDelete" v-hasPermi="['task:taskorderrefund:remove']">
          <a-icon type="delete" />{{$t('通用.按钮.删除')}}
        </a-button>
        <a-button type="primary" @click="handleExport" v-hasPermi="['task:taskorderrefund:export']">
          <a-icon type="download" />{{$t('通用.按钮.导出')}}
        </a-button>
        <table-setting
          :style="{float: 'right'}"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList" />
      </div>
      <!-- 增加修改 -->
      <create-form
        ref="createForm"
        @ok="getList"
      />
      <!-- 审核弹框 -->
      <a-modal title="审核售后申请" :visible="auditVisible" @ok="handleAuditSubmit" @cancel="handleAuditCancel" :confirmLoading="auditLoading">
        <a-form :label-col="{ span: 4 }" :wrapper-col="{ span: 20 }">
          <a-form-item label="审核结果">
            <a-radio-group v-model="auditResult">
              <a-radio :value="5050">通过</a-radio>
              <a-radio :value="5060">拒绝</a-radio>
            </a-radio-group>
          </a-form-item>
          <a-form-item label="拒绝原因" v-if="auditResult === 5060">
            <a-textarea v-model="auditRefuseReason" placeholder="请输入拒绝原因" :rows="4" />
          </a-form-item>
        </a-form>
      </a-modal>
      <!-- 数据展示 -->
      <a-table
        :loading="loading"
        :size="tableSize"
        @change="handleSortChange"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :pagination="false"
        :bordered="tableBordered"
      >
        <span slot="refundTime" slot-scope="text, record">
          {{ parseTime(record.refundTime) }}
        </span>
        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>
        <span slot="operation" slot-scope="text, record">
          <a v-if="record.refundStatus === 5010" @click="handleAudit(record)" v-hasPermi="['task:taskorderrefund:edit']">
            <a-icon type="check-circle" />审核
          </a>
          <a-divider type="vertical" v-if="record.refundStatus === 5010" v-hasPermi="['task:taskorderrefund:remove']" />
          <!-- <a @click="handleDelete(record)" v-hasPermi="['task:taskorderrefund:remove']">
            <a-icon type="delete" />{{$t('通用.按钮.删除')}}
          </a> -->
        </span>
      </a-table>
      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :pageSizeOptions="pageSizeOptions"
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="total => getTotal(total)"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { pageTaskRefund, delTaskRefund, auditTaskRefund } from '@/api/task/taskRefund'
import CustomDictTag from "@/components/DictCustomTag";
import {mapGetters} from 'vuex'
import moment from 'moment';
import CreateForm from './modules/CreateForm'
import { tableMixin } from '@/store/table-mixin'

export default {
  name: 'TaskOrderRefund',
  components: {
    CustomDictTag,
    CreateForm
  },
  mixins: [tableMixin],
  data () {
    return {
      list: [],
      pageSizeOptions: ['10', '20', '50', '100'],
      filteredInfo: {},
      sortedInfo : {},
      selectedRowKeys: [],
      selectedRows: [],
      //预览封面
      previewImageVisible: false,
      previewUrl: false,
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      // 审核弹框
      auditVisible: false,
      auditLoading: false,
      auditResult: 5050,
      auditRefuseReason: '',
      auditRow: null,
      // 查询参数
      queryParam: {
        taskTitle: undefined,
        refundStatus: undefined,
        reason: undefined,
        refundPic: undefined,
        refuseReason: undefined,
        beforeStatus: undefined,
        beforePayStatus: undefined,
        refundTime: undefined,
        pageNum: 1,
        pageSize: 10
      },
      columns: [
        {
          title: '原订单编号',
          dataIndex: 'orderNo',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '任务标题快照',
          dataIndex: 'taskTitle',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '申请人',
          dataIndex: 'userName',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '申请人电话',
          dataIndex: 'mobile',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '售后状态',
          dataIndex: 'refundStatus',
          ellipsis: true,
          align: 'center',
          customRender: (text) => {
            const statusMap = {
              5010: '待审核',
              5048: '退款处理中',
              5050: '退款完成',
              5060: '审核拒绝',
              5070: '售后关闭',
            }
            return statusMap[text] || text
          }
        },
        {
          title: '退款金额',
          dataIndex: 'refundAmount',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '退款原因',
          dataIndex: 'reason',
          ellipsis: true,
          align: 'center'
        },
        // {
        //   title: '退款凭证图片',
        //   dataIndex: 'refundPic',
        //   ellipsis: true,
        //   align: 'center'
        // },
        {
          title: '售后说明',
          dataIndex: 'remark',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '拒绝原因',
          dataIndex: 'refuseReason',
          ellipsis: true,
          align: 'center'
        },
        // {
        //   title: '退款前订单状态',
        //   dataIndex: 'beforeStatus',
        //   ellipsis: true,
        //   align: 'center'
        // },
        // {
        //   title: '退款前支付状态',
        //   dataIndex: 'beforePayStatus',
        //   ellipsis: true,
        //   align: 'center'
        // },
        // {
        //   title: '实际退款时间',
        //   dataIndex: 'refundTime',
        //   scopedSlots: { customRender: 'refundTime' },
        //   ellipsis: true,
        //   align: 'center'
        // },
        {
          title: '创建时间',
          dataIndex: 'createTime',
          scopedSlots: { customRender: 'createTime' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('通用.文本.操作'),
          dataIndex: 'operation',
          width: '18%',
          scopedSlots: { customRender: 'operation' },
          align: 'center'
        }
      ]
    }
  },
  filters: {
  },
  created () {
    this.getList()
  },
  computed: {
    ...mapGetters(['customDict'])
  },
  watch: {
  },
  methods: {
    moment,
    getTotal(total) {
      return this.$t('通用.文本.共')+total+this.$t('通用.文本.条')
    },
    /** 查询任务订单售后申请列表 */
    getList () {
      this.loading = true
     pageTaskRefund(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },

    /** 搜索按钮操作 */
    handleQuery () {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.queryParam = {
        taskTitle: undefined,
        refundStatus: undefined,
        reason: undefined,
        refundPic: undefined,
        refuseReason: undefined,
        beforeStatus: undefined,
        beforePayStatus: undefined,
        refundTime: undefined,
        pageNum: 1,
        pageSize: 10
      }
      this.handleQuery()
    },
    handleSortChange(pagination, filters, sorter) {
      this.filteredInfo = filters
      this.sortedInfo = sorter
      if (sorter.order) {
        /** 排序字段 sortField **/
        /** 排序方式  sortOrder**/
        this.queryParam.sortField = sorter.columnKey
        if (this.queryParam.sortField==='createTime') {
          this.queryParam.sortField= 'id'
        }
        this.queryParam.sortOrder = sorter.order === 'ascend' ? 'asc' : 'desc'
        this.getList()
      } else {
        this.queryParam.sortField = '';
        this.queryParam.sortOrder = ''
        this.getList()
      }
    },
    onShowSizeChange (current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    previewImageCancel() {
      this.previewImageVisible = false;
    },
    handleRecordPreview(url) {
      this.previewUrl = url
      this.previewImageVisible = true
    },
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    /** 审核按钮操作 */
    handleAudit (row) {
      this.auditRow = row
      this.auditResult = 5050
      this.auditRefuseReason = ''
      this.auditVisible = true
    },
    /** 审核弹框-确定 */
    handleAuditSubmit () {
      var that = this
      if (this.auditResult === 5060 && !this.auditRefuseReason) {
        this.$message.error('拒绝原因不能为空', 3)
        return
      }
      this.auditLoading = true
      const params = { id: this.auditRow.id, isPass: this.auditResult=== 5060?false:true }
      if (this.auditResult === 5060) {
        params.refuseReason = this.auditRefuseReason
      }
      auditTaskRefund(params).then(response => {
        if (response.code === '20001') {
          that.$message.success(this.auditResult === 5050 ? '审核通过成功' : '已拒绝该售后申请', 3)
          that.auditVisible = false
          that.getList()
        }
      }).finally(() => {
        that.auditLoading = false
      })
    },
    /** 审核弹框-取消 */
    handleAuditCancel () {
      this.auditVisible = false
      this.auditResult = 5050
      this.auditRefuseReason = ''
      this.auditRow = null
    },
    /** 删除按钮操作 */
    handleDelete (row) {
      var that = this
      const ids = row.id || this.ids
      if(row.id){
        this.ids = []
        this.ids.push(row.id)
      }
      this.$confirm({
        title: this.$t('通用.文本.确认删除所选中数据'),
        onOk () {
          return delTaskRefund(that.ids)
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              const message = that.$t('通用.文本.删除成功')
              that.$message.success(message,3)
          })
        },
        onCancel () {
          //取消清空删除ids列表
          that.ids = []
        }
      })
    },
    /** 导出按钮操作 */
    handleExport () {
      var that = this
      this.$confirm({
        title: this.$t('通用.文本.是否确认导出'),
        content: this.$t('通用.文本.此操作将导出当前条件下所有数据而非选中数据'),
        onOk () {
          that.download('task/task/order/refund/export',
            that.queryParam
          , `任务订单售后申请_${new Date().getTime()}.xlsx`)
        },
        onCancel () {}
      })
    }
  }
}
</script>
